import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/store/authStore'
import { useQueryClient } from '@tanstack/react-query'

export default function HeaderAuth() {
  const { isAuthenticated, user, logout, isLoading } = useAuthStore()
  const { t, i18n } = useTranslation()
  const queryClient = useQueryClient()

  const handleLogout = () => {
    queryClient.clear() // Clear all cached queries
    logout()
  }

  if (isLoading) {
    return (
      <div className="w-8 h-8 bg-[rgb(var(--muted))] dark:bg-white/10 rounded-full animate-pulse"></div>
    )
  }

  if (isAuthenticated && user) {
    return (
      <div className="flex items-center space-x-3">
        <span className="text-sm text-[rgb(var(--foreground-muted))]">
          {user.email}
        </span>
        <button
          onClick={handleLogout}
          className="text-sm font-medium text-[rgb(var(--foreground-muted))] hover:text-[rgb(var(--foreground))] transition-colors cursor-pointer"
        >
          {t('auth.signOut')}
        </button>
      </div>
    )
  }

  return (
    <Link
      to={`/${i18n.language}/auth/login`}
      className="text-sm font-medium text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-100 transition-colors cursor-pointer px-2 py-1 whitespace-nowrap"
    >
      {t('auth.signIn')}
    </Link>
  )
}